import { render, staticRenderFns } from "./DocxTemplateImportDialog.vue?vue&type=template&id=4a91aa12&scoped=true"
import script from "./DocxTemplateImportDialog.vue?vue&type=script&lang=js"
export * from "./DocxTemplateImportDialog.vue?vue&type=script&lang=js"
import style0 from "./DocxTemplateImportDialog.vue?vue&type=style&index=0&id=4a91aa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91aa12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
